import PropTypes from 'prop-types';
import classnames from 'classnames';

import ButtonGroup from '@scalero-inc/forno-button-group';
import Tooltip from '@scalero-inc/forno-tooltip';

import {
  useReadOnlyView,
  useReadOnlyViewDispatch,
} from '../../read-only-view-context';

import styles from './style.module.css';
import { codeReadOnlyDevicesOptions } from '../../read-only-view-context/constants';

function getSizeLabel(value) {
  return `${Math.floor(parseInt(value, 10))}px`;
}

function ReadOnlyHeaderDevicesButtons({ className }) {
  const customClassName = classnames(
    'editor-header-devices-buttons',
    styles['editor-header-devices-buttons'],
    className,
    {}
  );
  const { viewPreviewSize } = useReadOnlyView();
  const { setViewColumns } = useReadOnlyViewDispatch();

  const onViewChange = (value) => {
    setViewColumns(value[0]);
  };

  const sizeLabel = getSizeLabel(viewPreviewSize);

  const tooltipClassName = 'font-paragraph-s-sb';

  return (
    <div className={customClassName}>
      <ButtonGroup
        size="s"
        type="radio"
        theme="dark"
        variant="subtle"
        onChange={onViewChange}
      >
        {codeReadOnlyDevicesOptions.map((item) => {
          const Icon = item.icon;
          return (
            <Tooltip
              key={item.value}
              theme="dark"
              content={<p className={tooltipClassName}>{item.tooltipText}</p>}
            >
              <ButtonGroup.Button
                value={item.value}
                className="cannoli-button-group-item"
              >
                <Icon />
              </ButtonGroup.Button>
            </Tooltip>
          );
        })}
      </ButtonGroup>
      <div className={styles['size-indicator-wrapper']}>
        <p className="font-block-s-sb">W:</p>
        <div className={styles['size-indicator']}>
          <Tooltip
            theme="dark"
            placement="bottom-end"
            content={<p className={tooltipClassName}>Current preview width</p>}
          >
            <p className="font-block-s">{sizeLabel}</p>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

ReadOnlyHeaderDevicesButtons.propTypes = {
  className: PropTypes.string,
};

ReadOnlyHeaderDevicesButtons.defaultProps = {
  className: null,
};

export default ReadOnlyHeaderDevicesButtons;
